const COLOUR_NAMES: Readonly<Record<string, string>> = {
  '#3D6FD1': 'Blue',
  '#CC4038': 'Red',
  '#3E9455': 'Green',
};

/** A channel is known by its colour in the room, never by a slot number. */
export const colourName = (hex: string): string => COLOUR_NAMES[hex] ?? hex;
